import { render, staticRenderFns } from "./edgeComp.vue?vue&type=template&id=805b4f72"
import script from "./edgeComp.vue?vue&type=script&lang=js"
export * from "./edgeComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports